"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
exports.workspaceMemberships = graphql_tag_1.default `
  query workspaceMemberships(
    $workspaceId: ID,
    $userId: ID,
    $skip: Int,
    $take: Int,
    $deleted: [Boolean!],
    $isActive: [Boolean!],
    $searchQuery: String
  ) {
    workspaceMembershipsCount(
      userId: $userId,
      workspaceId: $workspaceId,
      deleted: $deleted,
      isActive: $isActive,
      searchQuery: $searchQuery
    )
    workspaceMemberships(
      workspaceId: $workspaceId,
      userId: $userId,
      skip: $skip,
      take: $take,
      deleted: $deleted,
      isActive: $isActive,
      searchQuery: $searchQuery
    ) {
      archived
      createdAt
      deleted
      firstInvitedAt
      id
      isActive
      isWorkspaceAdmin
      joinedAt
      updatedAt
      workspace {
        id
        name
        isWorkspaceAnalyticsEnabled
        enableSubscriberTools
        resourceUrl
        resourceAdminUrl
      }
      user {
        id
        email
        fullName
        isAppAdmin
        createdAt
        hasPassword
        resourceUrl
        resourceAdminUrl
        acceptedInvite {
          id
          createdAt
        }
        latestInvitation {
          id
          createdAt
          error
        }
      }
    }
  }
`;
//# sourceMappingURL=workspaceMemberships.js.map